import { render, staticRenderFns } from "./je-gegevens.vue?vue&type=template&id=d5346992"
import script from "./je-gegevens.vue?vue&type=script&lang=js"
export * from "./je-gegevens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports